const ListarTransportadoras = () => import('@/domains/shared/cadastros/transportadoras/views/Listar')
const AdicionarTransportadora = () => import('../views/Adicionar')
const EditarTransportadora = () => import('../views/Editar')
const VisualizarTransportadora = () => import('../views/Visualizar')
const routes = [
    {
        name: 'listarTransportadorasEmissor',
        path: '/emissor/transportadoras',
        alias: ['/emissor/transportadoras/index'],
        component: ListarTransportadoras,
    },
    {
        name: 'adicionarTransportadorasEmissor',
        path: '/emissor/transportadoras/adicionar',
        component: AdicionarTransportadora,
        meta: {
            fullScreen: true
        }
    },
    {
        name: 'editarTransportadorasEmissor',
        path: '/emissor/transportadoras/editar/:id',
        component: EditarTransportadora,
        meta: {
            fullScreen: true
        }
    },
    {
        name: 'visualizarTransportadorasEmissor',
        path: '/emissor/transportadoras/visualizar/:id',
        component: VisualizarTransportadora,
    }
]

export default routes
